import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { CATEGORIES } from '../../utils/Constants';
import HandleData from '../../utils/HandleData';

class Categories extends Component {
  
  handleMobileClick = (e) => {
    this.props.handleMobileClick();
    this.handleCatClick(e);
  }
  handleCatClick = (e) => {
    var li = e.currentTarget.parentNode;
    var ul = li.parentNode;
    var target = ul.parentNode;
    target.classList.remove('show');

  }
  categories = HandleData.sortData(CATEGORIES, 'name');

  render(){

    return(
      <div className={`categories ${this.props.catClass}`}>
        <ul className="categories-list">
          { this.categories.map((cat, idx) => (
          <li key={idx}>
            <NavLink 
              onClick={this.handleMobileClick} 
              to={`/businesses/${cat.dir}`}>
                {cat.name}
            </NavLink>
          </li>
          ))
          }
        </ul>
      </div>
    );
  }
}
export default Categories;


// WEBPACK FOOTER //
// ./src/components/blocks/Categories.js